import { render, staticRenderFns } from "./bmmap.vue?vue&type=template&id=b5bffe2a&scoped=true&"
import script from "./bmmap.vue?vue&type=script&lang=js&"
export * from "./bmmap.vue?vue&type=script&lang=js&"
import style0 from "./bmmap.vue?vue&type=style&index=0&id=b5bffe2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bffe2a",
  null
  
)

export default component.exports